<div class="flex flex-row justify-center">
  <div class="w-4on5 md-w-full">
    <h2 class="title-applications">Applications</h2>
    <mic-table [config]="tableConfig" [dataSource]="dataSource">
      <ng-container *micCellTemplate="let tableRow; name: 'status'">
        <div (click)="onClick(tableRow)" class="flex flex-row items-center table-row-status" [ngClass]="tableRow.status">
          <mat-icon>{{ util.getTableRowStatusIcon(tableRow.status) }}</mat-icon>
          <span>{{ util.getTableRowStatusLabel(tableRow.status) }}</span>
        </div>
      </ng-container>

      <ng-container *micTableRowMenu="let item">
        <button type="button" mat-menu-item (click)="details(item)"><mat-icon>visibility</mat-icon> Details</button>
        <button type="button" mat-menu-item (click)="remove(item)"><mat-icon>delete</mat-icon> Delete</button>
      </ng-container>
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="There is no element to display."> </mic-empty-state>
      </ng-container>
    </mic-table>
    <div class="btn-addUser">
      <button mat-raised-button color="primary" (click)="onAddApplication()">Add an application</button>
    </div>
  </div>
</div>

<mic-alert-center [hideDelay]="1"></mic-alert-center>
